const $ = window.jQuery;

$( () => {

    // $('.hero-video__video').click( function() {
    //     $(this).toggleClass('hero-video__video--playing');
    //     const video = $(this).find('video')[0];
    //     if( $(this).hasClass('hero-video__video--playing') ) {
    //         video.play();
    //     } else {
    //         video.pause();
    //         video.currentTime = 0;
    //     }
    // } );

} );